/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *==================================================
 */
import React from "react";
import styled from "styled-components";
import { Backdrop, CircularProgress } from "@material-ui/core";
import { useProgressValue } from "../context";

const CustomBackdrop: React.FC<any> = (props: any) => {
  const { inProgress } = useProgressValue();
  return (
    <Backdrop {...props} open={inProgress}>
      <CircularProgress />
    </Backdrop>
  );
};

const LoadingBackDrop = styled(CustomBackdrop)`
  ${({ theme }) => `
  z-index: ${theme.zIndex.drawer + 1}
`}
`;
export default LoadingBackDrop;
